'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _createClassNames = require('../components/createClassNames');

var _createClassNames2 = _interopRequireDefault(_createClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = (0, _createClassNames2.default)('Hits');

var Hits = function Hits(_ref) {
  var hits = _ref.hits,
      className = _ref.className,
      HitComponent = _ref.hitComponent;
  return (
    // Spread the hit on HitComponent instead of passing the full object. BC.
    // ex: <HitComponent {...hit} key={hit.objectID} />
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(cx(''), className) },
      _react2.default.createElement(
        'ul',
        { className: cx('list') },
        hits.map(function (hit) {
          return _react2.default.createElement(
            'li',
            { className: cx('item'), key: hit.objectID },
            _react2.default.createElement(HitComponent, { hit: hit })
          );
        })
      )
    )
  );
};

Hits.propTypes = {
  hits: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  className: _propTypes2.default.string,
  hitComponent: _propTypes2.default.func
};

Hits.defaultProps = {
  className: '',
  hitComponent: function hitComponent(props) {
    return _react2.default.createElement(
      'div',
      {
        style: {
          borderBottom: '1px solid #bbb',
          paddingBottom: '5px',
          marginBottom: '5px',
          wordBreak: 'break-all'
        }
      },
      JSON.stringify(props).slice(0, 100),
      '...'
    );
  }
};

exports.default = Hits;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/components/Hits.js
// module id = 1252
// module chunks = 142807904292071